import React, { Component } from 'react'
import firebase from 'firebase'
import Lines from '../Lines'

import './styles/CompetencySectionStyles.css'


class CompetencySection extends Component {
    constructor(props) {
        super(props)

        this.state = {
            title: '',
            descr: '',
            items: []
        }
    }

    componentDidMount() {

        const dbRef = firebase.database().ref('sections/CompetencySection')

        dbRef.on('value', this.setData.bind(this))
    }

    setData(snapshot) {
        const data = snapshot.val()

        if (data && data.items) {
            let items = []

            for (let key in data.items) {
                if (data.items[key].isVisible) {
                    items.push(data.items[key])
                }
            }

            this.setState({
                ...data,
                items: items
            })
        }
    }

    renderMetrics(number) {
        return number.toString().split('').map((item, i) => {

            return (
                <div key={'MetricNumber' + i} className="MetricNumber">
                    {item}
                </div>
            )
        })
    }

    renderTags(tags) {
        if (!tags) return
        let items = []

        for (let key in tags) {
            items.push(tags[key])
        }

        if (items && items.length > 0) {
            return items.map((item, i) => {
                return (
                    <div key={'CompetencyTag_' + i} className="CompetencyTag">
                        {`- ${item.title}`}
                    </div>
                )
            })
        }
    }

    renderCompetencyItem() {

        return this.state.items.map((item, i) => {

            return (
                <div key={`CompetencyItem${i}`} className="CompetencyItemWrapper column is-5 is-offset-1 ">
                    <div className="columns is-mobile">

                        <div className="CompetencyItemIconWrapper column is-gapless">
                            <div className="CompetencyIcon">
                                <div className="CompetencyIconContent" style={{ backgroundImage: (item.icon && item.icon.length) ? `url("${item.icon[0].url}")` : 'none' }}>

                                </div>
                            </div>
                        </div>

                        <div className="CompetencyItemContentWrapper column ">
                            <div className="CompetencyPhoto" style={{ backgroundImage: (item.photo && item.photo.length) ? `url("${item.photo[0].url}")` : 'none' }} />
                            <div className="CompetencyItemHeaderWrapper">
                                {item.title}
                            </div>
                            <div className="CompetencyItemTagsWrapper">
                                {this.renderTags(item.tags)}
                            </div>
                            <div className="CompetencyItemMetricsWrapper">
                                {this.renderMetrics(item.metrics)}
                                <span className="CompetencyItemMetricsText">
                                    {'м2 сдано'}
                                </span>
                            </div>
                        </div>

                    </div>
                </div>
            )
        })
    }

    render() {

        return (
            <div className="CompetencySection">

                <div className="CompetencySectionContentWrapper">
                    <Lines opacity={1} color={'#febb04'} />
                    <div className="CompetencySectionContentColumn">
                        <div className="CompetencySectionHeaderWrapper">
                            <div className="CompetencySectionTitleWrapper columns is-mobile">
                                <h2 className="column is-11 is-offset-1">{this.state.title}</h2>
                            </div>
                            <div className="CompetencySectionDescriptionWrapper columns is-mobile">
                                <p className="column is-5 is-offset-1">{this.state.descr}</p>
                            </div>
                        </div>
                        <div className="CompetencySectionTwoColumnsWrapper columns is-multiline is-mobile">
                            {this.renderCompetencyItem()}
                        </div>
                    </div>
                </div>

                <div className="FakeFullLines ">
                    <div className="FakeFullLinesInner"></div>
                </div>

            </div>
        )
    }
}

export default CompetencySection


// WEBPACK FOOTER //
// ./src/Components/Sections/CompetencySection.js